module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home-page"
    }
  }, [_c('div', {
    attrs: {
      "id": "fullpage"
    }
  }, [_c('div', {
    staticClass: "section"
  }, _vm._l((_vm.slides), function(slide, key) {
    return _c('hero-slider', {
      key: key,
      attrs: {
        "heading": slide.heading,
        "subHeading": slide.subHeading,
        "content": slide.content,
        "background": slide.background
      }
    })
  })), _vm._v(" "), _vm._l((_vm.sections), function(section, index) {
    return _c('div', {
      staticClass: "section",
      class: {
        'fp-auto-height': section.cta, 'align-bottom': section.alignBottom, 'get-started': section.getStarted
      },
      style: ({
        background: section.background
      })
    }, [_c('app-section', {
      attrs: {
        "index": index,
        "heading": section.heading,
        "content": section.content,
        "btnText": section.btnText,
        "image": section.image,
        "order": section.order,
        "button": section.button,
        "enter": section.enter,
        "animEnter": section.animEnter,
        "animLeave": section.animLeave,
        "appFooter": section.appFooter,
        "title": section.title,
        "subTitle": section.subTitle,
        "getStarted": section.getStarted,
        "alignBottom": section.alignBottom
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "section fp-auto-height",
    attrs: {
      "id": "footer"
    }
  }, [_c('app-footer')], 1)], 2), _vm._v(" "), _c('ul', {
    staticClass: "hidden-xs",
    attrs: {
      "id": "sidebar-nav"
    }
  }, [_c('li', [_c('a', {
    class: {
      'active': _vm.nav.section1
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.navigate(1)
      }
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      'active': _vm.nav.section2
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.navigate(2)
      }
    }
  }, [_vm._v("iOS App")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      'active': _vm.nav.section4
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.navigate(4)
      }
    }
  }, [_vm._v("Android App")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      'active': _vm.nav.section5
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.navigate(5)
      }
    }
  }, [_vm._v("Apple iPad")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      'active': _vm.nav.section7
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.navigate(7)
      }
    }
  }, [_vm._v("Android Tablet")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      'active': _vm.nav.section8
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.navigate(8)
      }
    }
  }, [_vm._v("Smart Watch")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      'active': _vm.nav.section9
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.navigate(9)
      }
    }
  }, [_vm._v("Get Started")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20730a76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomePage.vue
// module id = 76
// module chunks = 0